import { CalendarCheck, Truck, BadgeCheck } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { scrollToId } from "@/lib/site";

const STEPS = [
  {
    icon: CalendarCheck,
    title: "Book Online or Text Us",
    body: "Select your service online or message us directly on WhatsApp for a fast quote.",
  },
  {
    icon: Truck,
    title: "We Come to You",
    body: "Our mobile service unit arrives fully equipped at your home, office, or wherever the vehicle sits.",
  },
  {
    icon: BadgeCheck,
    title: "Drive with Confidence",
    body: "Quality repairs performed right the first time — with honest pricing and a clear explanation of the work.",
  },
];

export const HowItWorks = () => (
  <section id="how-it-works" data-testid="how-it-works-section" className="relative bg-charcoal py-16 sm:py-24 lg:py-32 border-y border-white/10 noise-overlay">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal className="text-center">
        <Eyebrow>Three Easy Steps</Eyebrow>
        <h2 className="font-display font-extrabold uppercase text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-none">
          Book. <span className="text-stroke-green">We roll.</span> You drive.
        </h2>
      </Reveal>

      <div className="mt-16 relative">
        <div className="hidden md:block absolute top-[52px] left-[16%] right-[16%] h-px bg-gradient-to-r from-ember/10 via-ember/60 to-ember/10" />
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8">
          {STEPS.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.15}>
              <div className="relative text-center group" data-testid={`step-${i + 1}`}>
                <div className="relative mx-auto w-[104px] h-[104px]">
                  <span className="absolute inset-0 rounded-full border border-ember/30 group-hover:scale-110 transition-transform duration-300" />
                  <span className="absolute inset-2 rounded-full bg-panel border border-white/10 flex items-center justify-center group-hover:border-ember/50 group-hover:shadow-[0_0_28px_rgba(132,220,90,0.25)] transition-all duration-300">
                    <s.icon className="w-9 h-9 text-ember" strokeWidth={1.75} />
                  </span>
                  <span className="absolute -top-1 -right-1 font-mono2 text-xs bg-ember text-obsidian font-bold px-2 py-0.5 rounded-sm">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                </div>
                <h3 className="mt-6 font-display font-bold uppercase text-2xl tracking-tight">{s.title}</h3>
                <p className="mt-3 text-mist text-sm leading-relaxed max-w-xs mx-auto">{s.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>

      <Reveal delay={0.3} className="mt-14 text-center">
        <button
          data-testid="how-it-works-book-btn"
          onClick={() => scrollToId("#booking")}
          className="bg-ember text-obsidian font-display font-bold uppercase tracking-wider text-lg px-8 py-4 rounded-sm hover:bg-[#9BE873] hover:shadow-[0_0_32px_rgba(132,220,90,0.35)] hover:-translate-y-0.5 transition-all duration-200"
        >
          Start Step One Now
        </button>
      </Reveal>
    </div>
  </section>
);
